import { Default } from './default';
import { Dark } from './dark';
export * from './types';
export const CFStyleThemes = {
    DARK: Dark,
    DEFAULT: Default,
};
